import { render, staticRenderFns } from "./CategoriesListCard.vue?vue&type=template&id=834c02ba&"
import script from "./CategoriesListCard.vue?vue&type=script&lang=js&"
export * from "./CategoriesListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports